import { HTMLAttributes, ReactNode, RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import { useLenis } from '@/contexts/lenis'
import { MediaQuery } from '@/constants'

import { cn } from '@/lib/utils'

export type ImageParallaxProps = Omit<
  HTMLAttributes<HTMLDivElement>,
  'children'
> & {
  // eslint-disable-next-line no-unused-vars
  children: (ref: RefObject<HTMLImageElement>) => ReactNode
}

const ImageParallax = ({
  className,
  children,
  ...props
}: ImageParallaxProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const image = useRef<HTMLImageElement>(null)
  const { lenis } = useLenis()

  useGSAP(
    () => {
      if (!lenis || !image.current) return

      const matchMedia = gsap.matchMedia(ref)

      /* matchMedia.add(MediaQuery.SMALL, () => {
        gsap.fromTo(
          image.current,
          { yPercent: -15 },
          {
            scrollTrigger: {
              trigger: image.current,
              start: 'top 100%',
              end: 'bottom 0%',
              horizontal: false,
              scrub: true,
              once: false
            },
            yPercent: 0,
            ease: 'none'
          }
        )
      }) */

      matchMedia.add(MediaQuery.LARGE, () => {
        gsap.fromTo(
          image.current,
          { xPercent: -15 },
          {
            scrollTrigger: {
              trigger: image.current,
              start: 'left 100%',
              end: 'right 0%',
              horizontal: true,
              scrub: true,
              once: false
            },
            xPercent: 0,
            ease: 'none'
          }
        )
      })

      return () => {
        matchMedia.revert()
      }
    },
    { scope: image, dependencies: [lenis], revertOnUpdate: true }
  )

  return (
    <span
      ref={ref}
      className={cn(
        'relative isolate block overflow-hidden [&>*]:!h-[115%] lg:[&>*]:!h-[100%] lg:[&>*]:!w-[115%]',
        className
      )}
      {...props}
    >
      {children(image)}
    </span>
  )
}

export default ImageParallax
